// Module-level store for the current project name.
// Set when loading a project, read by ExportDialog for render history
// and EditorTopBar for live display.

import {useSyncExternalStore} from 'react'

let projectName: string | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const notify = () => {
  listeners.forEach((l) => l())
}

export const setProjectName = (name: string) => {
  if (projectName === name) return
  projectName = name
  notify()
}

export const getProjectName = (): string | null => projectName

export const clearProjectName = () => {
  if (projectName === null) return
  projectName = null
  notify()
}

export const useProjectName = (): string | null => useSyncExternalStore(subscribe, getProjectName, getProjectName)
